export function projection<T extends object, K extends keyof T>(
    obj: T,
    fields: K[]
): Pick<T, K> {
    const result = {} as Pick<T, K>;
    for (const field of fields) {
        if (field in obj) {
            result[field] = obj[field];
        }
    }
    return result;
}

export function createProjection<T extends object, K extends keyof T>(fields: K[]): (obj: T) => Pick<T, K> {
    return obj => projection(obj, fields);
}

